






























import Vue from "vue";
export default Vue.extend({
  props: {
    deleteDocuments: Array as () => string[],
  },
  computed: {
    multipleDocuments(): boolean {
      return this.deleteDocuments.length > 1;
    },
  },
});
